import {db, auth} from '@/firebase'
import axios from 'axios'

export default {
    salvarFormulario: (formulario: any) => {
        return db.collection('formularios').add({
            createdAt: new Date(),
            ...formulario
        })
    },
    atualizarFormulario(formularioId: string, formulario: any) {
        return db.collection('formularios').doc(formularioId).set(formulario)
    },
    criarNovoUsuario: (email, password) => auth.createUserWithEmailAndPassword(email, password),
    autenticarUsuario: (email, password) => auth.signInWithEmailAndPassword(email, password),
    resetarSenha: (email) => {
        auth.useDeviceLanguage()
        return auth.sendPasswordResetEmail(email)
    },
    logout: () => auth.signOut(),
    obterFormularioPorEmail: (email: string) => new Promise<{ id: string; formularioFromRepository: Data }>((resolve, reject) => {
        db.collection('usuarios')
            .where('email', '==', email).get()
            .then(querySnapshot => {
                if (querySnapshot.size === 0) {
                    reject()
                } else {
                    const usuarioId = querySnapshot.docs[0].id;
                    db.collection('formularios')
                        .where('usuarioId', '==', usuarioId)
                        .orderBy('createdAt', 'desc')
                        .limit(1)
                        .get()
                        .then(docs => {
                            if (docs.size === 0) {
                                reject()
                            } else {
                                const id = docs.docs[0].id
                                const formularioFromRepository = docs.docs[0].data()
                                resolve({id, formularioFromRepository})
                            }
                        })
                }
            })
    }),
    obterParticipacoesPorSegmento: () => new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_REPOSITORY_URL + '/participacoes-por-segmento')
            .then(response => resolve(response.data))
            .catch(erro => reject(erro))
    }),
    obterQuantidadeDemissoes: () => new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_REPOSITORY_URL + '/quantidade-de-demissoes')
            .then(response => resolve(response.data))
            .catch(erro => reject(erro))
    }),
    obterQuantidadeDemissoesPorSegmentos: () => new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_REPOSITORY_URL + '/demissoes-por-segmento')
            .then(response => resolve(response.data))
            .catch(erro => reject(erro))
    }),
    obterFuncionamentoEmpresas: () => new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_REPOSITORY_URL + '/funcionamento-das-empresas')
            .then(response => resolve(response.data))
            .catch(erro => reject(erro))
    }),
    obterReposicaoEstoque: () => new Promise((resolve, reject) => {
        axios.get(process.env.VUE_APP_REPOSITORY_URL + '/reposicao-estoque')
            .then(response => resolve(response.data))
            .catch(erro => reject(erro))
    })
}
